// dependencies
import React, { useState } from 'react';
import axios from 'axios';
import './../Home/Home.css';
import './../Contact/Contact.css';
import './Feedback.css';

const Contact = () => {
   const initialFormState = {
      name: '',
      // phone: '',
      email: '',
      institute: '',
      roll: '',
      comment: '',
   };

   // states
   const [formState, setFormState] = useState(initialFormState);
   const [submitting, setSubmitting] = useState(false);
   const [showMessage, setShowMessage] = useState();

   // destructured data
   const { name, email, institute, roll, comment } = formState;

   const formId = 'e0gUHJYy';
   const formSparkUrl = `https://submit-form.com/${formId}`;

   const submitForm = async (e) => {
      e.preventDefault();
      setSubmitting(true);
      await postSubmission();
      setSubmitting(false);
   };

   const postSubmission = async () => {
      const payload = {
         ...formState,
      };

      try {
         axios.post(formSparkUrl, payload);
         setShowMessage({
            text: 'Thanks for your feedback. This will help us in further improvement',
         });
         setFormState(initialFormState);
      } catch (err) {
         setShowMessage({
            text: 'Sorry, there was a problem. Try again later.',
         });
      }
   };

   const updateFormControl = (e) => {
      const { id, value } = e.target;
      const formKey = id;
      const updatedFormState = { ...formState };
      updatedFormState[formKey] = value;
      setFormState(updatedFormState);
   };

   return (
      <div className="home-content contact">
         <h2 className="common-blue main-heading text-center text">
            Send Your Feedback
         </h2>
         <hr />
         {showMessage && (
            <div className="show-msg common-blue text-center">
               {showMessage.text}
            </div>
         )}
         <form onSubmit={submitForm}>
            <label htmlFor="name" className="common-blue">
               Enter Your Name*
            </label>
            <br />
            <input
               onChange={updateFormControl}
               id="name"
               value={name}
               type="text"
               name="name"
               className="roll"
               placeholder="Your name . . ."
               required
            />
            <br />
            {/* <label htmlFor="phone" className="common-blue">
               Enter Your Phone*
            </label>
            <br />
            <input
               onChange={updateFormControl}
               id="phone"
               value={phone}
               type="tel"
               name="phone"
               className="roll"
               placeholder="Your phone . . ."
               required
            />
            <br /> */}
            <label htmlFor="email" className="common-blue">
               Enter Your Email*
            </label>
            <br />
            <input
               onChange={updateFormControl}
               id="email"
               value={email}
               type="email"
               name="email"
               className="roll"
               placeholder="Your email . . ."
               required
            />
            <br />
            <label htmlFor="institute" className="common-blue">
               Enter Your Institute Name*
            </label>
            <br />
            <input
               onChange={updateFormControl}
               id="institute"
               value={institute}
               type="text"
               name="institute"
               className="roll"
               placeholder="Your institute name . . ."
               required
            />
            <br />
            <label htmlFor="roll" className="common-blue">
               Enter Your Board Roll*
            </label>
            <br />
            <input
               onChange={updateFormControl}
               id="roll"
               value={roll}
               type="number"
               name="roll"
               className="roll"
               placeholder="Your board roll . . ."
               required
            />
            <br />
            <label htmlFor="comment" className="common-blue">
               Write Your Comment*
            </label>
            <br />
            <textarea
               onChange={updateFormControl}
               id="comment"
               value={comment}
               name="comment"
               className="roll"
               rows="8"
               placeholder="Your comment..."
               required
            ></textarea>
            <br />
            <div className="form-btn text-center">
               <button className="btn-form" disabled={submitting} type="submit">
                  {submitting ? 'Sending...' : `Send`}
               </button>
            </div>
         </form>
      </div>
   );
};

export default Contact;
